import {useLayoutEffect, useRef, useState} from 'react'
import {useLocation} from 'react-router-dom'

export function Bond() {
  const location = useLocation()

  const
    [radius, setRadius] = useState(0),
    [visible, setVisible] = useState(false),
    requestRef = useRef(null)

  const startAnimation = () => {
    cancelAnimationFrame(requestRef.current) // 💥 сброс предыдущего
    setVisible(true)
    setRadius(0)

    let start
    const
      duration = 4000,
      maxRadius = Math.hypot(window.innerWidth, window.innerHeight)

    const grow = timestamp => {
      if (!start)
        start = timestamp

      const progress = Math.min((timestamp - start) / duration, 1)
      setRadius(progress * maxRadius)

      if (progress < 1) {
        requestRef.current = requestAnimationFrame(grow)
      } else {
        setVisible(false)
      }
    }

    requestRef.current = requestAnimationFrame(grow)

    return () => cancelAnimationFrame(requestRef.current)
  }

  useLayoutEffect(startAnimation, [])

  useLayoutEffect(() => {
    if (!['/prepaywall1', '/prepaywall2', '/paywall', '/'].includes(location.pathname))
      return

    return startAnimation()
  }, [location.pathname])

  if (!visible)
    return null

  const
    cx = window.innerWidth / 2,
    cy = window.innerHeight / 2

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      pointerEvents: 'none',
      zIndex: 9999,
    }}>
      <svg width="100%" height="100%">
        <defs>
          <mask id="mask">
            <rect width="100%" height="100%" fill="white"/>
            <circle cx={cx} cy={cy} r={radius} fill="black"/>
          </mask>
        </defs>
        <rect width="100%" height="100%" fill="black" mask="url(#mask)"/>
      </svg>
    </div>
  )
}